/*
    网络请求
*/

import axios from 'axios';
import Secret from '@/core/Secret';
import { URL } from '@/axios/URL';
import { secret, resHandler } from '@/core/utils';

//请求基地址
axios.defaults.baseURL = URL.BASE_URL;

//拦截请求加密
axios.interceptors.request.use((config) => {
	// console.log(config.url);
	// console.table(config.data);
    config.data = secret.encrypt(config.data);
    // console.log( config , 'config')
    return config;
});

//拦截响应解密
axios.interceptors.response.use((res) => {
    let resData = res.data;
    if (resData.data && Secret.isEncryptResult(resData.data)) {
        resData.data = secret.decrypt(resData.data) || {};
    }
	// console.log(res.config.url);
	// console.table(resData);
    return resData;

}, resHandler.netConnectionFail);

export default axios;
export { URL } from './URL';
export { noSign } from './noSign';

